import * as React from "react";
import type { SVGProps } from "react";

interface InjuryTimeoutProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const InjuryTimeout = ({ cancelled = false, ...props }: InjuryTimeoutProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd" transform="translate(2.5 1)">
      <ellipse cx={9.75} cy={12.925} fill="#FFF" rx={8.087} ry={8.143} />
      <path
        fill="#000"
        fillRule="nonzero"
        stroke="#FFF"
        strokeLinejoin="round"
        strokeWidth={0.75}
        d="m12.302.796.002.027.007.161c0 .732-.593 1.325-1.325 1.325h-.38v.53c4.96.54 8.769 4.716 8.769 9.732 0 5.415-4.422 9.804-9.875 9.804s-9.875-4.389-9.875-9.804c0-5.016 3.81-9.192 8.77-9.732v-.53h-.38A1.325 1.325 0 0 1 6.688.984V.95c0-.732.593-1.325 1.325-1.325h2.972c.674 0 1.239.506 1.316 1.17ZM1.837 12.57c0 4.199 3.43 7.603 7.663 7.603s7.663-3.404 7.663-7.603-3.43-7.603-7.663-7.603-7.663 3.405-7.663 7.603Z"
      />
      <rect width={3} height={10} x={8} y={7.5} fill="#FF1212" rx={1} />
      <rect
        width={3}
        height={10}
        x={8}
        y={7.5}
        fill="#FF1212"
        rx={1}
        transform="rotate(90 9.5 12.5)"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default InjuryTimeout;
